import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import InputFormat from "../inputForm";
import CountryRegionData from "./data.json";
import settings from "./settings";
import CityVietnam from "./dist/tinh_tp.json";

class CityDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      regions: this.getRegions(props.country)
    };
    this.getRegions = this.getRegions.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.country !== this.props.country) {
      const defaultRegions = this.getRegions(nextProps.country);

      this.setState({ regions: [...defaultRegions] });
    }
  }

  getRegions(country) {
    if (!country) {
      return [];
    }

    const { countryValueType } = this.props;
    const searchIndex =
      countryValueType === settings.DISPLAY_TYPE_FULL
        ? "countryName"
        : "countryShortCode";
    let regions = CountryRegionData.find(i => i[searchIndex] === country);
    if (regions) regions = regions.regions;

    if (country !== "VN") {
      if (!regions || regions.length === 0) {
        console.error(
          "Error. Unknown country passed: " +
          country +
          '. If you\'re passing a country shortcode, be sure to include countryValueType="short" on the CityDropdown'
        );
        return [];
      }

      return regions.map(region => {
        return { regionName: region.name, regionShortCode: region.shortCode };
      });
    } else {
      return Object.values(CityVietnam);
    }
  }

  getRegionList() {
    const { labelType, valueType, country } = this.props;
    const { regions = [] } = this.state;
    if (country !== "VN") {
      return regions.map(({ regionName, regionShortCode }) => {
        const label =
          labelType === settings.DISPLAY_TYPE_FULL
            ? regionName
            : regionShortCode
              ? regionShortCode
              : "";
        const value =
          valueType === settings.DISPLAY_TYPE_FULL
            ? regionName
            : regionShortCode
              ? regionShortCode
              : "";
        return (
          <MenuItem key={regionShortCode} value={value}>
            {label}
          </MenuItem>
        );
      });
    } else {
      return regions.map((e, index) => {
        return (
          <MenuItem key={index} value={e.name}>
            {e.name}
          </MenuItem>
        );
      });
    }
  }

  // there are two default options. The "blank" option which shows up when the user hasn't selected a country yet, and
  // a "default" option which shows
  getDefaultOption() {
    const {
      blankOptionLabel,
      showDefaultOption,
      defaultOptionLabel,
      placeholder,
      country
    } = this.props;
    if (!country) {
      return (
        <MenuItem key="default" value=" ">
          {blankOptionLabel}
        </MenuItem>
      );
    } else if (showDefaultOption) {
      return (
        <MenuItem key="default" value=" ">
          {defaultOptionLabel || placeholder}
        </MenuItem>
      );
    } else return null;
  }

  render() {
    const {
      t,
      label,
      value,
      onChange,
      onBlur,
      id,
      name,
      disabled,
      classes,
      disable,
      InputLabelProps = {},
      SelectProps = {},
      ...arbitraryProps
    } = this.props;

    const attrs = {
      ...arbitraryProps,
      name,
      label,
      value,
      onChange: e => onChange(e),
      onBlur: e => onBlur(e),
      disabled: disabled
    };
    if (id) {
      attrs.id = id;
    }
    if (classes) {
      attrs.className = classes;
    }
    return (
      <InputFormat
        {...attrs}
        select
        SelectProps={{
          displayEmpty: true,
          ...SelectProps
        }}
        InputLabelProps={{
          ...InputLabelProps
        }}
      >
        {this.getDefaultOption()}
        {this.getRegionList()}
      </InputFormat>
    );
  }
}

const styles = theme => ({
  title: {
    fontSize: "1.5rem"
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%"
  },
  input: {},
  label: {
    fontWeight: 410
  }
});

CityDropdown.propTypes = {
  country: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  id: PropTypes.string,
  classes: PropTypes.object,
  blankOptionLabel: PropTypes.string,
  showDefaultOption: PropTypes.bool,
  defaultOptionLabel: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  labelType: PropTypes.string,
  valueType: PropTypes.string,
  disabled: PropTypes.bool,
  customOptions: PropTypes.array,
  placeholder: PropTypes.string,
  disableUnderline: PropTypes.bool
};

CityDropdown.defaultProps = {
  country: "",
  value: "",
  name: "rcrs-region",
  id: "",
  classes: {},
  blankOptionLabel: "-",
  showDefaultOption: true,
  defaultOptionLabel: "Select City",
  onChange: () => { },
  onBlur: () => { },
  countryValueType: settings.DISPLAY_TYPE_FULL,
  labelType: settings.DISPLAY_TYPE_FULL,
  valueType: settings.DISPLAY_TYPE_FULL,
  disabled: false,
  customOptions: []
};

export default translate("translations")(
  withStyles(styles, { withTheme: true })(CityDropdown)
);
